"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldPreviewLabel = exports.getLabelValue = exports.useStyles = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var React = _interopRequireWildcard(require("react"));

var _types = require("../../../../../../types");

var _usePkpass2 = require("../../../usePkpass");

var _lodash = require("lodash");

var _reactJss = require("react-jss");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _reactJss.createUseStyles)({
  root: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  field: {
    color: function color(_ref) {
      var labelColor = _ref.labelColor;
      return labelColor;
    },
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    fontSize: function fontSize(_ref2) {
      var theme = _ref2.theme;
      return 11 * theme.scale;
    }
  },
  backfield: {
    color: '#7d7d7d',
    fontSize: function fontSize(_ref3) {
      var theme = _ref3.theme;
      return theme.scale * 12;
    },
    marginBottom: function marginBottom(_ref4) {
      var theme = _ref4.theme;
      return theme.scale * 4;
    }
  }
});
exports.useStyles = useStyles;

var getLabelValue = function getLabelValue(values, language) {
  var label = values.label;

  if ((0, _lodash.isObject)(label)) {
    return label[language];
  }

  return label;
};

exports.getLabelValue = getLabelValue;

var FieldPreviewLabel = function FieldPreviewLabel(props) {
  var _usePkpass = (0, _usePkpass2.usePkpass)(),
      language = _usePkpass.language;

  var fieldsType = props.fieldsType,
      field = props.field,
      theme = props.theme,
      labelColor = props.labelColor;
  var classes = useStyles({
    theme: theme,
    labelColor: labelColor
  });
  return /*#__PURE__*/React.createElement("div", {
    className: fieldsType === _types.PkpassFieldsType.BackFields ? undefined : classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: fieldsType === _types.PkpassFieldsType.BackFields ? classes.backfield : classes.field
  }, getLabelValue(field, language) || /*#__PURE__*/React.createElement("span", null, "\xA0")));
};

exports.FieldPreviewLabel = FieldPreviewLabel;
FieldPreviewLabel.propTypes = {
  labelColor: _propTypes.default.string.isRequired
};
//# sourceMappingURL=FieldPreviewLabel.js.map